import { render, staticRenderFns } from "./addIncomChannle.vue?vue&type=template&id=64a5873e&"
import script from "./addIncomChannle.vue?vue&type=script&lang=js&"
export * from "./addIncomChannle.vue?vue&type=script&lang=js&"
import style0 from "./addIncomChannle.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('64a5873e')) {
      api.createRecord('64a5873e', component.options)
    } else {
      api.reload('64a5873e', component.options)
    }
    module.hot.accept("./addIncomChannle.vue?vue&type=template&id=64a5873e&", function () {
      api.rerender('64a5873e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/datalist/components/addIncomChannle.vue"
export default component.exports